module.exports = __webpack_public_path__ + "img/bayer-logo.e3d7d1d2.svg";